import { useContext } from 'react'

import { Avatar } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps } from '@mantine/core'

import { AIChatBotContext } from '../../context'
import useStyles from './index.styles'

type Props = {
  borderSize?: number
  avatarSize?: number
  maxWidthPercent?: number
  onClick?: () => void
} & BoxProps

export const AvatarFocus = ({
  borderSize = 1,
  avatarSize = 32,
  maxWidthPercent = 80,
  className,
  classNames,
  styles,
  onClick,
  ...props
}: Props) => {
  const { avatar } = useContext(AIChatBotContext)
  const { classes, cx } = useStyles(
    { borderSize, maxWidthPercent },
    {
      name: 'AIChatBotWidget__ConversationHeader',
      classNames,
      styles,
    },
  )
  return (
    <Box className={cx(classes.root, className)} {...props} onClick={onClick}>
      <Avatar
        size={avatarSize}
        src={avatar}
        classNames={{ root: classes.avatarRoot, image: classes.avatarImage }}
      />
    </Box>
  )
}
